/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function EmojiWatch({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.6 6a.6.6 0 1 0-1.2 0v2a.6.6 0 0 0 .176.424l1.5 1.5a.6.6 0 1 0 .848-.848L8.6 7.75z" /><path fill="currentColor" fillRule="evenodd" d="M3.901 4.965q0-.02.004-.04l.28-2.247A2.6 2.6 0 0 1 6.766.4h2.47a2.6 2.6 0 0 1 2.58 2.278l.28 2.248.004.039A5.08 5.08 0 0 1 13.1 8a5.08 5.08 0 0 1-1.001 3.035l-.004.04-.28 2.248a2.6 2.6 0 0 1-2.58 2.277h-2.47a2.6 2.6 0 0 1-2.58-2.277l-.28-2.248-.004-.04A5.08 5.08 0 0 1 2.9 8c0-1.137.372-2.187 1.001-3.035m1.475-2.139A1.4 1.4 0 0 1 6.766 1.6h2.468a1.4 1.4 0 0 1 1.39 1.226l.108.867A5.1 5.1 0 0 0 8 2.9c-1.005 0-1.942.29-2.732.793zM8 13.1c1.005 0 1.942-.29 2.732-.793l-.108.867a1.4 1.4 0 0 1-1.39 1.226H6.766a1.4 1.4 0 0 1-1.39-1.226l-.108-.867c.79.502 1.727.793 2.732.793M4.1 8a3.9 3.9 0 1 1 7.8 0 3.9 3.9 0 0 1-7.8 0" clipRule="evenodd" /></svg>;
}
;